import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=aafed604&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "./Index.vue?vue&type=style&index=0&id=aafed604&prod&lang=stylus"
import style1 from "./Index.vue?vue&type=style&index=1&id=aafed604&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aafed604",
  null
  
)

export default component.exports